import { IFavoriteRestaurant } from "../models/IFavoriteRestaurant";
import { configWithUserToken } from "./config";

export const getFavoriteRestaurants = (pageIndex = 0, pageSize = 10) => {
  return configWithUserToken.get<IFavoriteRestaurant[]>("Favorite", {
    params: { pageIndex, pageSize },
  });
};
